import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { WorkSummaryPage } from '@/features/dashboards/pages/WorkSummaryPage';
import { systemDashboardSearchSchema } from '@/features/dashboards/types/dashboard.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/dashboards/system/$userId')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: systemDashboardSearchSchema,
  component: function SystemWorkSummaryRoute() {
    const { userId } = Route.useParams();
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ErrorBoundary moduleName="Work Summary">
        <Suspense fallback={<PageLoader />}>
          <WorkSummaryPage
            userId={userId}
            period={{ dateFrom: search.dateFrom, dateTo: search.dateTo }}
            viewedRowList="systemDashboardMembers"
            onNoHistory={() => void navigate({ to: '/dashboards/system', search })}
          />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
